import ChatBox from "./components/ChatBox";
import { v4 as uuidv4 } from 'uuid';

const RealStreamingChat = () => {
  // 真实的API调用函数
  const handleRealStream = async (query, signal) => {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000);
      const sessionId = localStorage.getItem('session_id') || uuidv4();
      localStorage.setItem('session_id', sessionId);
      const response = await fetch('https://api.wisepoll.com/stream', {
      // const response = await fetch('http://192.168.3.6:8088/stream', {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          {
            "question": query,
            "session_id": sessionId  // 确保每次请求传递
          }
        ),
        signal: signal 
      });
      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.body;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('请求已被用户中止');
        return;
      } else {
        console.error('API请求失败:', error);
        return null;
      }
    }
    
  };

  return (
    <div style={{ height: '100vh' }}>
      <ChatBox
        onSendMessage={handleRealStream}
        placeholder="输入消息..."
        loadingText="AI正在思考中..."
      />
    </div>
  );
};

export default RealStreamingChat;
